import { Logo } from "@/components/Logo";

export default function AuthPage({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#050505]">
      <div className="hidden lg:flex relative flex-col justify-between p-12 border-r border-[#2A2A2A] grid-lines grain overflow-hidden">
        <Logo />
        <div className="relative z-10 max-w-md">
          <p className="font-mono text-xs text-[#00FF9D] mb-4">// RUNWAY RECALIBRATED: +7.4 MO</p>
          <h1 className="font-display text-4xl xl:text-5xl font-semibold leading-tight">Calibrate your runway. Then grow into it.</h1>
          <p className="mt-6 text-[#A3A3A3]">14 days free, no card needed. Stripe, bank and QuickBooks tuned into one live model.</p>
        </div>
        <p className="font-mono text-xs text-[#A3A3A3]">© CalibRunway</p>
      </div>
      <div className="flex flex-col items-center justify-center p-6 gap-8">
        <Logo className="lg:hidden" testid="brand-logo-mobile" />
        <div data-testid="auth-form-container">{children}</div>
        <p data-testid="auth-terms-notice" className="max-w-sm text-center text-xs text-[#A3A3A3]">
          By creating an account or signing in you agree to the <a href="/terms" target="_blank" rel="noreferrer" data-testid="auth-terms-link" className="text-[#00FF9D] underline">Terms of Service and Privacy Policy</a>. CalibRunway is a forecasting tool, not financial advice.
        </p>
      </div>
    </div>
  );
}
